var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0381 3H5.03809C3.93352 3 3.03809 3.89543 3.03809 5V19C3.03809 20.1046 3.93352 21 5.03809 21H19.0381C20.1427 21 21.0381 20.1046 21.0381 19V5C21.0381 3.89543 20.1427 3 19.0381 3Z",
    stroke: "#F66700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0381 15L16.0381 10L5.03809 21",
    stroke: "#F66700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53809 10C9.36651 10 10.0381 9.32843 10.0381 8.5C10.0381 7.67157 9.36651 7 8.53809 7C7.70966 7 7.03809 7.67157 7.03809 8.5C7.03809 9.32843 7.70966 10 8.53809 10Z",
    stroke: "#F66700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo_icon.344b2f22a7f358828591cb6f4201462f.svg";
export { ForwardRef as ReactComponent };